import React from "react";

import { Modal } from "react-bootstrap";

import './super-admin-settings-editor.scss';

const DeleteAlert = (props) => {
    let {handleClose , handleDelete, name, show} = props;
    const title = "Do you want to delete " + name +" setting ?";

    return(
        <Modal 
            centered 
            size='sm'
            show= {show} 
        >
            <Modal.Body className="alert-title text-break" > {title} </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-setting-light btn-sm" onClick={handleClose}>No</button>
                <button type="button" className="btn btn-setting-primary btn-sm" onClick={handleDelete}>Yes</button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteAlert;